export function readAppUserFarmNames(
  importFarmName: string | string[] | undefined
): string[] {
  if (Array.isArray(importFarmName)) {
    return importFarmName;
  }
  return (importFarmName ?? "")
    .split(",")
    .map((farmName) => farmName.trim())
    .filter(Boolean);
}
